import { SchemaV3Constants } from "../erd-editor-schema/dist/v3/schema/index.js";
//#region src/constants/schema.ts
var CanvasType = SchemaV3Constants.CanvasType;
var CanvasTypeList = SchemaV3Constants.CanvasTypeList;
var Show = SchemaV3Constants.Show;
var ColumnType = SchemaV3Constants.ColumnType;
var ColumnTypeList = SchemaV3Constants.ColumnTypeList;
var Database = SchemaV3Constants.Database;
var DatabaseList = SchemaV3Constants.DatabaseList;
var Language = SchemaV3Constants.Language;
var LanguageList = SchemaV3Constants.LanguageList;
var NameCase = SchemaV3Constants.NameCase;
var NameCaseList = SchemaV3Constants.NameCaseList;
var BracketType = SchemaV3Constants.BracketType;
var BracketTypeList = SchemaV3Constants.BracketTypeList;
var RelationshipType = SchemaV3Constants.RelationshipType;
SchemaV3Constants.RelationshipTypeList;
var StartRelationshipType = SchemaV3Constants.StartRelationshipType;
SchemaV3Constants.StartRelationshipTypeList;
var ReferentialAction = SchemaV3Constants.ReferentialAction;
SchemaV3Constants.ReferentialActionList;
var Direction = SchemaV3Constants.Direction;
SchemaV3Constants.DirectionList;
var ColumnOption = SchemaV3Constants.ColumnOption;
var ColumnUIKey = SchemaV3Constants.ColumnUIKey;
var OrderType = SchemaV3Constants.OrderType;
SchemaV3Constants.OrderTypeList;
var LockSettingType = SchemaV3Constants.LockSettingType;
var LockSettingTypeList = SchemaV3Constants.LockSettingTypeList;
var LockSettingFields = SchemaV3Constants.LockSettingFields;
SchemaV3Constants.InvertedLockSettings;
var NameViewMode = SchemaV3Constants.NameViewMode;
var NameViewModeList = SchemaV3Constants.NameViewModeList;
var CANVAS_SIZE_MAX = SchemaV3Constants.CANVAS_SIZE_MAX;
var CANVAS_SIZE_MIN = SchemaV3Constants.CANVAS_SIZE_MIN;
var CANVAS_ZOOM_MAX = SchemaV3Constants.CANVAS_ZOOM_MAX;
var CANVAS_ZOOM_MIN = SchemaV3Constants.CANVAS_ZOOM_MIN;
var DDLScriptPosition = SchemaV3Constants.DDLScriptPosition;
var DDLScriptPositionList = SchemaV3Constants.DDLScriptPositionList;
var BracketTypeMap = {
	[BracketType.none]: "",
	[BracketType.backtick]: "`",
	[BracketType.doubleQuote]: "\"",
	[BracketType.singleQuote]: "'"
};
var ReferentialActionToSQL = {
	[ReferentialAction.noAction]: "NO ACTION",
	[ReferentialAction.cascade]: "CASCADE",
	[ReferentialAction.setNull]: "SET NULL",
	[ReferentialAction.setDefault]: "SET DEFAULT",
	[ReferentialAction.restrict]: "RESTRICT"
};
//#endregion
export { BracketType, BracketTypeList, BracketTypeMap, CANVAS_SIZE_MAX, CANVAS_SIZE_MIN, CANVAS_ZOOM_MAX, CANVAS_ZOOM_MIN, CanvasType, CanvasTypeList, ColumnOption, ColumnType, ColumnTypeList, ColumnUIKey, DDLScriptPosition, DDLScriptPositionList, Database, DatabaseList, Direction, Language, LanguageList, LockSettingFields, LockSettingType, LockSettingTypeList, NameCase, NameCaseList, NameViewMode, NameViewModeList, OrderType, ReferentialAction, ReferentialActionToSQL, RelationshipType, Show, StartRelationshipType };
